import * as NS from './namespace';
import { IUser } from '@/model/security';
import { IIndicator, ISensorDevice } from '@/model/meta';

const getters: NS.IAdministrationGetters = {
    getUsersGrid(state: NS.IAdministrationState): IUser[] {
        return state.usersGrid;
    },
    getChooseDevicesData(state: NS.IAdministrationState): ISensorDevice[] {
        return state.chooseDevicesData;
    },
    getIndicatorsGrid(state: NS.IAdministrationState): IIndicator[] {
        return state.indicatorsGrid;
    },
    getDevicesGrid(state: NS.IAdministrationState): ISensorDevice[] {
        return state.devicesGrid;
    },
    getChooseIndicatorData(state: NS.IAdministrationState): IIndicator[] {
        return state.chooseIndicatorData;
    },

    
    getPreloader(state: NS.IAdministrationState): boolean {
        return state.preloader;
    },
    getFailLoading(state: NS.IAdministrationState): boolean {
        return state.failLoading;
    },
    getActiveFormRequest(state: NS.IAdministrationState): boolean {
        return state.activeFormRequest;
    },
    getFailedFormRequest(state: NS.IAdministrationState): boolean {
        return state.failedFormRequest;
    },
};

/** Реализация геттеров модуля администрирования */
export default getters;